import { useProgressStore } from '~/store/progress'

export default defineNuxtRouteMiddleware(async (to, from) => {
  if(useProgressStore().navigating === 'back'){
    to.meta.pageTransition.name = 'mp-transition-back'
  } else if(useProgressStore().navigating === 'forward') {
    to.meta.pageTransition.name = 'mp-transition'
  }
})
